const getInlineFilterItems = (self) => [
  {
    id: 'all',
    label: self.$t('routeOptimization.status.all'),
  },
  {
    id: 'SUCCESS',
    label: self.$t('routeOptimization.status.success'),
  },
  {
    id: 'PENDING',
    label: self.$t('routeOptimization.status.pending'),
  },
  {
    id: 'CANCELED',
    label: self.$t('routeOptimization.status.canceled'),
  },
  {
    id: 'FAILED',
    label: self.$t('routeOptimization.status.failed'),
  },
]

export default getInlineFilterItems
